<template>
  <div
    :class="{
      [$style.baseRange]: true,
      [$style.baseRangeNewDesign]: isNewDesign,
      [$style.land]: el.is.land,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone,
      [$style.isHalf]: input.width === 'half',
      [$style.hasInputHeading]: input.heading,
      [$style.secondInput]: input.secondInput
    }"
  >
    <!-- image -->
    <div v-if="input.img" :class="$style.imgHeader">
      <img :src="getImg()" alt="item image" />
    </div>
    <!-- label -->
    <div :class="$style.tooltipWrapper">
      <label
        :class="{
          [$style.inputHeading]: true,
          [$style.inputHeadingNewDesign]: isNewDesign
        }"
        >{{ input.heading
        }}<span
          :class="{
            [$style.inputHeading2]: true,
            [$style.inputHeading2NewDesign]: isNewDesign,
            [$style.headingMinWidht]: input.minWidthHeading2
          }"
          >{{ input.heading_2 }}</span
        ></label
      >
      <!-- explanation tooltip -->
      <BaseTooltip
        v-if="input.tooltip"
        :hoverMode="true"
        :text="input.tooltip"
        :class="$style.explanationTooltip"
        position="absolute"
        ><span
          :class="{
            [$style.explanationTooltipIcon]: !isNewDesign,
            [$style.explanationTooltipIconNewDesign]: isNewDesign
          }"
          >?</span
        ></BaseTooltip
      >
    </div>

    <!-- form -->
    <form :class="$style.form">
      <!-- price ranges -->
      <div :class="$style.priceRanges">
        <!-- price range -->
        <div :class="$style.priceRange">
          <!-- decrease button -->
          <div
            @click.prevent="onDecrease"
            :class="{
              [$style.iconMinus]: true,
              [$style.iconMinusNewDesign]: isNewDesign
            }"
          >
            -
          </div>
          <!-- increase button -->
          <div
            @click.prevent="onIncrease"
            :class="{
              [$style.iconPlus]: true,
              [$style.iconPlusNewDesign]: isNewDesign
            }"
          >
            +
          </div>

          <!-- info box -->
          <span
            v-if="input.format === false"
            :class="$style.infoBox"
            :style="{ left: colorLabel }"
            >{{ selectedValue }} {{ input.unit }}</span
          >
          <span
            v-else
            :class="$style.infoBox"
            v-bind:style="{ left: colorLabel }"
            >{{ selectedValue | formatNumber }} {{ input.unit }}</span
          >

          <!-- range input -->
          <input
            type="range"
            :name="input.formName.name"
            :step="input.step"
            id="range"
            :min="input.min"
            :max="input.max"
            v-model.number="selectedValue"
            :style="{ background: color }"
            @change="rangeHandler"
            :class="{
              [$style.inputRange]: true,
              [$style.inputRangeNewDesign]: isNewDesign
            }"
          />
        </div>

        <!-- min and max info -->
        <div v-if="input.format === false" :class="$style.minAndMax">
          <span>{{ input.min }} {{ input.unit }} </span>
          <span>{{ input.max }} {{ input.unit }} </span>
        </div>
        <div v-else :class="$style.minAndMax">
          <span>{{ input.min | formatNumber }} {{ input.unit }} </span>
          <span>{{ input.max | formatNumber }} {{ input.unit }} </span>
        </div>
      </div>

      <!-- number input wrapper-->
      <BaseTooltip
        :text="this.message"
        :show="showTooltip"
        :class="$style.inputWrapper"
      >
        <!-- number input -->
        <input
          :autocomplete="stopAutocomplete && 'nope'"
          type="text"
          id="range"
          :min="input.min"
          :max="input.max"
          :class="{
            [$style.numberInput]: true,
            [$style.numberInputNewDesign]: isNewDesign
          }"
          :step="input.step"
          :value="formatNumber(selectedValueNumInput)"
          @focus="focusNumberInput"
          @keypress.enter.prevent="blurNumberHandler"
          @input="inputNumberHandler"
          @blur="blurNumberHandler"
        />
        <!-- edit icon -->
        <img
          :class="$style.editIcon"
          src="@/assets/images/icon-edit.svg"
          alt="edit"
        />
      </BaseTooltip>
      <!-- label text -->
      <label for="range" :class="{ [$style.infoLabelNewDesign]: isNewDesign }"
        >Alternativ eingeben</label
      >
    </form>
  </div>
</template>

<script>
import store from '@/store'
import BaseTooltip from '@/components/ui/BaseTooltip.vue'

export default {
  props: {
    input: {
      type: Object,
      required: true
    }
  },
  components: {
    BaseTooltip
  },
  data() {
    return {
      color:
        'linear-gradient(to right,#D4BB9F 0%,#D4BB9F 50%,#D8D8D8  50%, #D8D8D8 100%)',
      selectedValue: null,
      selectedValueNumInput: null,
      colorLabel: 0,
      numAsString: '',
      message: '',
      showTooltip: false,
      timeout: null,
      focused: false
    }
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    // ON HAUSANKER
    stopAutocomplete() {
      return !this.input.autocomplete && this.isNewDesign
    },
    inputMax() {
      return this.input.max
    },
    el() {
      return store.state.el
    }
  },
  methods: {
    formatThousands(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    },
    inputNumberHandler(e) {
      this.selectedValueNumInput = e.target.value
      if (this.input.format === false) {
        return
      }
      this.selectedValueNumInput = this.formatThousands(
        e.target.value.replace(/\./g, '')
      )
    },
    editMessage(num) {
      if (
        (this.input.numberMax && num > this.input.numberMax) ||
        (!this.input.numberMax && num > this.input.max)
      ) {
        this.message = this.input.validations.messageMax
      } else if (num < this.input.min) {
        this.message = this.input.validations.messageMin
      } else {
        this.message = ''
      }
      if (this.message) {
        this.showTooltip = true
        this.timeout = setTimeout(() => {
          this.showTooltip = false
        }, 4000)
      }
    },
    focusNumberInput(e) {
      this.showTooltip = false
      clearTimeout(this.timeout)
      if (this.focused) {
        return
      }
      this.focused = true
      this.selectedValueNumInput = ''
    },
    formatNumber(x) {
      if (this.focused) {
        return x
      }
      if (this.input.format === false || !this.selectedValueNumInput) {
        return x
      }
      let splitted = x.toString().split('')
      let arr = []
      for (let index = splitted.length - 1; index >= 0; index--) {
        if ((index + 1) % 3 === 0 && index < splitted.length - 1) {
          arr.push('.')
        }
        arr.push(splitted[splitted.length - 1 - index])
      }
      let final = this.input.unit
        ? arr.join('') + ' ' + this.input.unit
        : arr.join('')
      return final
    },
    blurNumberHandler(event) {
      event.target.blur()
      this.focused = false

      this.selectedValueNumInput = this.selectedValueNumInput
        ? this.selectedValueNumInput
        : this.selectedValue

      if (this.numAsString === event.target.value) {
        event.target.value = this.formatNumber(this.selectedValueNumInput)
        return
      }

      let num = event.target.value
        .replace(/\./g, '')
        .replace(this.input.unit, '')
        .replace(' ', '')
      if (isNaN(Number(num))) {
        this.selectedValueNumInput = this.selectedValue
        this.numAsString = event.target.value
        return
      }

      event.target.value = this.formatNumber(
        this.checkMinMax('number', Number(num))
      )

      this.numAsString = event.target.value
      this.emitData()
      this.editMessage(num)
    },
    onDecrease() {
      if (this.selectedValue > this.input.min) {
        if (this.selectedValue - this.input.step < this.input.min) {
          this.selectedValue = this.input.min
          this.selectedValueNumInput = this.selectedValue
        } else {
          this.selectedValue -= this.input.step
          this.selectedValueNumInput = this.selectedValue
        }
        this.emitData()
      }
    },
    onIncrease() {
      if (this.selectedValue < this.input.max) {
        if (this.selectedValue + this.input.step > this.input.max) {
          this.selectedValue = this.input.max
          this.selectedValueNumInput = this.selectedValue
        } else {
          this.selectedValue += this.input.step
          this.selectedValueNumInput = this.selectedValue
        }
        this.emitData()
      }
    },
    checkMinMax(type, num = 0) {
      // entered num input && there is separate num max on that input
      if (type === 'number' && this.input.numberMax) {
        if (num >= this.input.numberMax) {
          this.selectedValue = this.input.max
          this.selectedValueNumInput = this.input.numberMax
        } else if (num < this.input.numberMax && num > this.input.max) {
          this.selectedValue = this.input.max
          this.selectedValueNumInput = Number(num)
        } else {
          this.selectedValue = Number(num)
          this.selectedValueNumInput = Number(num)
        }
        if (this.selectedValue < this.input.min) {
          this.selectedValue = this.input.min
          this.selectedValueNumInput = this.input.min
        }
      }
      // entered num input and there is no separate num max on that input
      else if (!this.input.numberMax && type === 'number') {
        if (num > this.input.max) {
          this.selectedValue = this.input.max
          this.selectedValueNumInput = this.selectedValue
        } else if (num < this.input.min) {
          this.selectedValue = this.input.min
          this.selectedValueNumInput = this.input.min
        } else {
          this.selectedValue = num
          this.selectedValueNumInput = this.selectedValue
        }
      }
      // not entered num input
      else {
        this.selectedValueNumInput = this.selectedValue
        if (this.selectedValue < this.input.min) {
          this.selectedValue = this.input.min
          this.selectedValueNumInput = this.selectedValue
        }
        if (this.selectedValue > this.input.max) {
          this.selectedValue = this.input.max
          this.selectedValueNumInput = this.selectedValue
        }
      }
      return this.selectedValueNumInput
    },
    rangeHandler() {
      this.checkMinMax('range')
      this.emitData()
    },
    emitData() {
      const data = {
        slideName: this.input.slideName,
        formName: this.input.formName,
        name: this.input.name,
        isInvalid: false,
        value:
          this.selectedValueNumInput > this.selectedValue
            ? this.selectedValueNumInput
            : this.selectedValue
      }
      this.$emit('range', data)
    },
    getImg() {
      // note: newDesign
      if (this.input.imgV2 && this.isNewDesign) {
        return require('../../assets/images/' + this.input.imgV2)
      } else {
        return require('../../assets/images/' + this.input.img)
      }
    },
    calculateWidth() {
      const coef = 100 / ((this.input.max - this.input.min) / this.input.step)
      let value =
        ((this.selectedValue - this.input.min) / this.input.step) * coef

      if (this.selectedValue + this.input.step > this.input.max) {
        value = 100
      }
      if (this.selectedValue - this.input.step < this.input.min) {
        value = 0
      }
      this.colorLabel = value + '%'

      // note: new design
      if (this.isNewDesign) {
        this.color =
          'linear-gradient(to right, #cc6b4a 0%, #cc6b4a ' +
          value +
          '%, #ece8e5 ' +
          value +
          '%, #ece8e5  100%)'
      } else {
        this.color =
          'linear-gradient(to right, #D4BB9F 0%, #D4BB9F ' +
          value +
          '%, #D8D8D8  ' +
          value +
          '%, #D8D8D8  100%)'
      }
    }
  },
  filters: {
    formatNumber: x => {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  watch: {
    selectedValue(newValue, oldValue) {
      this.calculateWidth()
    },
    inputMax() {
      this.selectedValue = this.input.selectedValue
        ? this.input.selectedValue
        : this.input.default
      this.selectedValueNumInput = this.selectedValue
      this.calculateWidth()
      this.checkMinMax('range')
      if (this.input.max % 1000 === 500) {
        this.input.step = 500
      }
      if (
        this.input.max % 1000 === 0 &&
        (!this.input.selectedValue || this.input.selectedValue % 1000 === 0)
      ) {
        this.input.step = 1000
      }
    }
  },
  created() {
    // note: new design
    if (this.isNewDesign) {
      this.color =
        'linear-gradient(to right,#cc6b4a 0%,#cc6b4a 50%,#ece8e5 50%, #ece8e5 100%)'
    }
    this.selectedValue = this.input.selectedValue
      ? this.input.selectedValue
      : this.input.default
    this.selectedValueNumInput = this.selectedValue

    this.calculateWidth()
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';
.buttonPlusMinus {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 40px;
  height: 40px;
  margin-bottom: 0px;
  padding-bottom: 2px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-style: solid;
  border-width: 2px;
  border-color: #ccc;
  border-radius: 50%;
  -webkit-transition: color 400ms ease, border-color 400ms ease;
  transition: color 400ms ease, border-color 400ms ease;
  color: #ccc;
  font-size: 28px;
  line-height: 0px;
  cursor: pointer;
  user-select: none;
}

.tooltipWrapper {
  position: relative;
  display: flex;
}

.explanationTooltip {
  cursor: help;
  display: inline-block;
  position: absolute;
  top: -10px;
  right: -32px;
  height: 33px;
  width: 27px;
}

.explanationTooltipIcon {
  font-size: 17px;
  font-weight: bold;
  color: white;
  background-color: $color_green_1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 7px;
  height: 100%;
}

.explanationTooltipIconNewDesign {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 13px;
  border-radius: 50%;
  height: 27px;
  width: 27px;
  background: $color_bg_light;
  border: 2px solid $color_font_new;
  padding: 1px;
}

.imgHeader {
  width: fit-content;
  height: 69px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.baseRange {
  width: 477px;
  height: 50%;
}

.isHalf {
  width: 216px;
  min-height: 350px;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  display: flex;
}

.inputWrapper {
  position: relative;
  margin: 0 auto;
  .editIcon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    height: 19px;
    width: 19px;
  }
}

.priceRange {
  position: relative;
}

.minAndMax {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 42px;
  span {
    margin-top: 5px;
    font-size: 15px;
  }
}

.infoBox {
  display: none;
  position: absolute;
  bottom: 35px;
  justify-content: center;
  align-items: center;
  width: 102px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  transform: translateX(-50%);
  background-color: $color-bg-light;
  color: $color_font_2;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.priceRange:hover .infoBox {
  display: block;
}

.inputHeading {
  font-size: 18px;
  color: $color_font_3;
  margin-bottom: 43px;
  margin-top: 15px;
  display: block;
  font-weight: 700;
}

// note: new design
.inputHeadingNewDesign {
  font-family: Arya;
  font-style: normal;
  font-weight: bold;
}

.inputHeading2 {
  display: block;
  font-weight: 500;
}

// note: new design
.inputHeading2NewDesign {
  font-family: Arya;
  font-style: normal;
}

.headingMinWidht {
  min-width: 300px;
}

.form {
  display: flex;
  flex-direction: column;
  text-align: center;
  label {
    font-size: 15px;
    color: $color_grey_5;
    margin-top: 7px;
  }
}

.range {
  width: 100%;
}

.numberInput {
  width: 100%;
  height: 50px;
  border: none;
  text-align: center;
  font-size: 22px;
  color: $color_font_2;
  border: 2px $color_grey_3 solid;
}

// note: new design
.numberInputNewDesign {
  border: 2px solid #cecece;
  font-family: Arya;
  font-style: normal;
  font-weight: bold;
}

.numberInput:focus {
  outline: none;
  border: 2px solid $color_green_2;
}

// note: new design
.numberInputNewDesign:focus {
  outline: none;
  border: 2px solid $color_border_dark_new;
}

.slidecontainer {
  width: 100%; /* Width of the outside container */
}
.iconPlus {
  // width: fit-content;
  position: absolute;
  right: -55px;
  top: 50%;
  transform: translateY(-50%);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 40px;
  height: 40px;
  margin-bottom: 0px;
  padding-bottom: 2px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-style: solid;
  border-width: 2px;
  border-color: #ccc;
  border-radius: 20px;
  -webkit-transition: color 400ms ease, border-color 400ms ease;
  transition: color 400ms ease, border-color 400ms ease;
  color: #ccc;
  font-size: 28px;
  line-height: 0px;
  cursor: pointer;
  user-select: none;
}

// note: new design
.iconPlusNewDesign {
  border: 3px solid $color_progress_new;
  color: $color_progress_new;
  box-shadow: 0px 1px 6px rgba(38, 40, 37, 0.16),
    0px 6px 24px rgba(38, 40, 37, 0.04);
}

.iconMinus {
  position: absolute;
  top: 50%;
  left: -55px;
  transform: translateY(-50%);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 40px;
  height: 40px;
  margin-bottom: 0px;
  padding-bottom: 2px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-style: solid;
  border-width: 2px;
  border-color: #ccc;
  border-radius: 20px;
  -webkit-transition: color 400ms ease, border-color 400ms ease;
  transition: color 400ms ease, border-color 400ms ease;
  color: #ccc;
  font-size: 28px;
  line-height: 0px;
  cursor: pointer;
  user-select: none;
}

// note: new design
.iconMinusNewDesign {
  border: 3px solid $color_progress_new;
  color: $color_progress_new;
  box-shadow: 0px 1px 6px rgba(38, 40, 37, 0.16),
    0px 6px 24px rgba(38, 40, 37, 0.04);
}

.iconMinus:hover {
  color: #333;
  border: 2px solid #333;
}

// note: new design
.iconMinusNewDesign:hover {
  border: 3px solid #333;
}

.iconPlus:hover {
  color: #333;
  border: 2px solid #333;
}

// note: new design
.iconPlusNewDesign:hover {
  border: 3px solid #333;
}

.inputRange {
  width: 100%;
  -webkit-appearance: none;
  position: relative;
  cursor: grabbing;
  border-radius: 5px;
  background: transparent;
}

// firefox
.inputRange::-moz-range-thumb {
  -webkit-appearance: none;
  border: none;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background: $color_green_1;
  margin-top: -10px;
}

// note: new design
.inputRangeNewDesign::-moz-range-thumb {
  background: $color_bg_light;
  border: 3px solid $color_progress_new;
  box-sizing: border-box;

  /* drop shadow btn primary */
  box-shadow: 0px 1px 4px rgba(38, 40, 37, 0.3),
    0px 6px 12px rgba(38, 40, 37, 0.1);
}

.inputRange::-webkit-slider-runnable-track {
  width: 100%;
  height: 10px;
  border: none;
  border-radius: 5px;
}

.inputRange::-ms-fill-lower {
  background: $color_grey_6;
  border-radius: 10px;
}

.inputRange::-ms-fill-upper {
  background: $color_grey_7;
  border-radius: 10px;
}

.inputRange::-webkit-slider-thumb {
  -webkit-appearance: none;
  border: none;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background: $color_green_1;
  margin-top: -10px;
}

// note: new design
.inputRangeNewDesign::-webkit-slider-thumb {
  background: $color_bg_light;
  border: 3px solid $color_progress_new;
  box-sizing: border-box;

  /* drop shadow btn primary */
  box-shadow: 0px 1px 4px rgba(38, 40, 37, 0.3),
    0px 6px 12px rgba(38, 40, 37, 0.1);
}

.inputRange:focus {
  outline: none;
}

// note: new design
.infoLabelNewDesign {
  color: $color_font_new !important;
}

// note: LAND
.land {
  margin: 0 auto;

  &.baseRange {
    width: auto;
  }

  &.isHalf {
    width: 50%;
    // min-height: 350px;
  }
  .inputHeading {
    width: 140%;
  }
  .inputHeading2 {
    font-size: 17px;
  }
}

// note: PORT
.port {
  &.isHalf {
    width: 216px;
    // min-height: 350px;
  }
  .inputHeading {
    font-size: 22px;
    // margin-bottom: 12px;
  }
  .inputHeading2 {
    font-size: 16px;
  }
  .minAndMax {
    font-size: 16px;
    // margin-bottom: 8px;
    font-weight: bold;
  }
}

// note: PHONE
.phone {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-top: -25px;

  &.baseRange {
    width: 100%;
  }

  .inputHeading {
    width: 100%;
  }

  &.hasInputHeading {
    .imgHeader {
      margin-top: 40px;
    }
    .inputHeading {
      margin-bottom: 20px;
    }
    &.secondInput {
      .imgHeader {
        margin-top: -10px;
      }
    }
  }

  .priceRange {
    width: calc(100% - 110px);
    margin: 15px auto;
  }
  &.isHalf {
    width: 100%;
    min-height: 250px;
  }
  .form {
    width: 100%;
    label {
      font-size: 14px;
    }
  }
  .numberInput {
    width: 98%;
    font-weight: bold;
    font-size: 22px;
  }
  .infoBox {
    width: 87px;
    font-size: 16px;
    height: 30px;
    bottom: 30px;
  }
  .minAndMax {
    width: 96%;
    margin: 0 auto;
    span {
      font-size: 16px;
      font-weight: bold;
      margin-top: 11px;
      margin-bottom: 14px;
    }
  }
  .iconMinus {
    left: -50px;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .iconPlus {
    right: -50px;

    img {
      width: 30px;
      height: 30px;
    }
  }
}
</style>
